import { render, staticRenderFns } from "./ProductLabelQuestion.vue?vue&type=template&id=6613e230&scoped=true&"
import script from "./ProductLabelQuestion.vue?vue&type=script&lang=js&"
export * from "./ProductLabelQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabelQuestion.vue?vue&type=style&index=0&id=6613e230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6613e230",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VFileInput,VSelect})
